import { MedicinesSection } from './MedicinesSection';
import { safeArray } from '../utils/dataTransformers';

/**
 * Medicine Section Wrapper Component
 * Adapts the existing MedicinesSection to work with the refactored structure
 */
export const MedicineSection = ({ formikProps, todayDate, patientPlanData }) => {
    const {
        values,
        errors,
        touched,
        setFieldValue,
        setFieldTouched,
        handleSubmit,
        isSubmitting,
    } = formikProps;

    return (
        <MedicinesSection
            values={values}
            errors={errors}
            touched={touched}
            allDates={safeArray(patientPlanData?.allDates)}
            todayDate={todayDate}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            handleSubmit={handleSubmit}
            loading={isSubmitting}
            setError={() => { }} // Error handling is done at parent level
        />
    );
};
